module.exports = __webpack_public_path__ + "static/media/Trainbanner.d727edbb.png";